import styled from '@emotion/styled';

import { tokens } from '@hotjar/hotsauce';

const IFrame = styled.iframe`
  border-radius: ${tokens.radius.m};
`;

interface YoutubeVideoProps {
  videoUrl: string | null;
}

export const YoutubeVideo = ({ videoUrl }: YoutubeVideoProps): JSX.Element | null => {
  return videoUrl ? (
    <IFrame
      width="400"
      height="180"
      src={videoUrl}
      title="YouTube video player"
      frameBorder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
    />
  ) : null;
};
